// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7EnNA","media":"Banner_media__1omAx","sloganContainer":"Banner_sloganContainer__Tjr9u","slogan":"Banner_slogan__NJp1E","subSlogan":"Banner_subSlogan__uvGhw"};